attachEvent('.video-block__button', 'click', (ev) => {
  const parentElem = ev.target.closest('.video-block');
  const videoElem = parentElem.querySelector('video');
  parentElem.classList.add('is-playing');
  videoElem.play();
});
